/**
 * Vantage Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ImaginePayMessage } from './imaginePayMessage';

export interface ImaginePayMessageFile {
  id?: string;
  rowId?: number;
  datasetId?: string;
  fileName?: string | null;
  processedDate?: string;
  createdBy?: string | null;
  createdDate?: string;
  updatedBy?: string | null;
  updatedDate?: string | null;
  isDeleted?: boolean;
  deletedBy?: string | null;
  deletedDate?: string | null;
  contents?: string | null;
  imaginePayMessages?: Array<ImaginePayMessage> | null;
  processingStatus?: string | null;
}
